import api from "./api";

// Capa de servicios API del dominio "citas" (appointments / agenda) (FSD / capa API transversal).
// Wrappers de transporte finos: la construcción de payloads/params vive en el
// componente; aquí solo se centraliza el endpoint (un único lugar que tocar si cambia).

export const listAppointments = (params) => api.get("/appointments", { params });

/**
 * Huecos reales de un día, resueltos por el motor de la base.
 *
 * El endpoint existía desde su creación y **ningún componente lo llamaba**: el
 * modal pedía fecha y hora en un campo libre y nadie comprobaba si ese hueco
 * existía. Por eso se podía crear una cita un domingo a las 3 de la madrugada
 * desde la propia interfaz (doc 0396 · F0.8).
 *
 * `professionalId` a null significa «sin preferencia»: devuelve los huecos donde
 * al menos un profesional esté libre, con `freeCount` y `freeProfessionals`.
 */
export const getAvailability = (params) =>
  api.get("/appointments/availability", { params });
export const createAppointment = (payload) => api.post("/appointments", payload);
export const updateAppointment = (appointmentId, payload) =>
  api.patch(`/appointments/${appointmentId}`, payload);
export const updateAppointmentStatus = (appointmentId, payload) =>
  api.patch(`/appointments/${appointmentId}/status`, payload);
